if (typeof ProductPage !== 'function') {

  class ProductPage extends HTMLElement {

    constructor() {

      super();

      this.pickupAvailabilityExtended = this.querySelector('pickup-availability-extended');

      this.$carousel = $(this.querySelector('[data-js-product-gallery]'));
      this.$nav = $(this.querySelector('[data-js-product-gallery-thumbnails]'));

      window.onresize = debounce(() => {
        this.$carousel.flickity('resize');
        this.$nav.flickity('resize');
      });
      window.onload = debounce(() => {
        this.$carousel.flickity('resize');
        this.$nav.flickity('resize');
      });

      // Product variant event listener for theme specific logic
      this.productVariants = this.querySelector('product-variants[data-main-product-variants]');
      if (this.productVariants) {
        this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
        this.onVariantChangeHandler({target: this.productVariants});

        // change colors
        this.productVariants.querySelectorAll('.product-variant__item').forEach(elm => {
          elm.addEventListener("mouseover", (event) =>  this.onVariantHover(event))
          elm.addEventListener("mouseout", () =>  this.onVariantHoverStop())
        });

        // finish loading lazy gallery imgs
        setTimeout(() => {
            this.$carousel[0]
              .querySelectorAll('.lazy-image img')
              .forEach((elm) => {
                elm.loading = 'eager';
              });
        }, 5000);

        this.querySelectorAll('.product-variant__item--radio').forEach(elm => {
          // click change variant
          elm.addEventListener('click', e => {
            if (elm.classList.contains('product-variant__item--color')) {
              elm.closest('.product-variant').querySelector('.product-variant__item-text-label').textContent = elm.querySelector('input').value;
            }
          });
        });
      }

      // show cart drawer when element is added to cart

      if (!document.body.classList.contains('template-cart') && KROWN.settings.cart_action == 'overlay') {

        let addToCartEnter = false;
        if (this.querySelector('[data-js-product-add-to-cart]')) {
          this.querySelector('[data-js-product-add-to-cart]').addEventListener('keyup', e => {
            if (e.keyCode == window.KEYCODES.RETURN) {
              addToCartEnter = true;
            }
          })
        }

        if (this.querySelector('[data-js-product-form]')) {
          this.querySelector('[data-js-product-form]').addEventListener('add-to-cart', () => {
            document.getElementById('site-cart-sidebar').show();
            if (document.getElementById('cart-recommendations-sidebar')) {
              document.getElementById('cart-recommendations-sidebar').generateRecommendations();
            }
            if (addToCartEnter) {
              setTimeout(() => {
                document.querySelector('#site-cart-sidebar [data-js-close]').focus();
              }, 200);
            }
          });
        }

      }

      // Check for models

      const models = this.querySelectorAll('product-model');
      if (models.length > 0) {
        window.ProductModel.loadShopifyXR();
        this.xrButton = this.querySelector('.product-gallery__view-in-space');
      }

      // hide buy now button if stock disabled

      const addToCartButton = this.querySelector('[data-js-product-add-to-cart][data-main-product-add-to-cart]');
      if (addToCartButton) {
        if (addToCartButton.classList.contains('disabled')) {
          this.querySelector('product-form').classList.add('disable-buy-button');
        } else {
          this.querySelector('product-form').classList.remove('disable-buy-button');
        }
        const buyObserver = new MutationObserver(() => {
          if (addToCartButton.classList.contains('disabled')) {
            this.querySelector('product-form').classList.add('disable-buy-button');
          } else {
            this.querySelector('product-form').classList.remove('disable-buy-button');
          }
        });
        buyObserver.observe(addToCartButton, {attributes: true, childList: false, subtree: false});
      }

      // update secondary price if present

      this.priceCompact = this.querySelector('[data-js-product-price-compact]');
      this.priceExtended = this.querySelector('[data-js-product-price-extended]');

      if (this.priceCompact) {
        this.priceCompact.priceOriginal = this.priceCompact.querySelector('[data-js-product-price-original]');
        this.priceCompact.priceOriginalKit = this.priceCompact.querySelector('[data-js-product-price-kit]');
        this.priceCompact.priceCompareOriginal = this.priceCompact.querySelector('[data-js-product-price-compare-original]');
        this.priceCompact.priceCompareKit = this.priceCompact.querySelector('[data-js-product-price-compare-kit]');
        this.priceCompact.priceUnit = this.priceCompact.querySelector('[data-js-product-price-unit]');
      }
      if (this.priceExtended) {
        this.priceExtended.priceOriginal = this.priceExtended.querySelector('[data-js-product-price-original]');
        this.priceExtended.priceOriginalKit = this.priceExtended.querySelector('[data-js-product-price-kit]');
        this.priceExtended.priceCompareOriginal = this.priceExtended.querySelector('[data-js-product-price-compare-original]');
        this.priceExtended.priceCompareKit = this.priceExtended.querySelector('[data-js-product-price-compare-kit]');
        this.priceExtended.priceSaving = this.priceExtended.querySelector('[data-js-product-price-saving]');
        this.priceExtended.priceUnit = this.priceExtended.querySelector('[data-js-product-price-unit]');
      }

      //is charities feature enabled? does charities_list exist?
      let charities_elem = document.getElementById('charities-list');
      if (charities_elem) {
        //turn into array
        let charities_list = charities_elem.innerHTML.split(',');

        let charities_select = document.getElementById('charity');
        if (charities_select) {
          //populate the dropdown
          for (const charity of charities_list) {
            let elem = document.createElement('option');
            elem.value = charity;
            elem.innerHTML = charity;
            charities_select.appendChild(elem);
          }
        }
      }

      // only one toggle group open at a time
      this.querySelectorAll('toggle-tab').forEach(allToggle => {
        allToggle.querySelector('[data-js-title]').addEventListener('click', () => {
          this.querySelectorAll('toggle-tab.opened').forEach(openedToggle => {
            if (allToggle !== openedToggle) {
              openedToggle.onClickHandler();
            }
          });
        });
      });
    }

    onVariantHover(event) {
      let hoverVariant = this.productVariants.getVariantData().find((variant) => {
        if (variant.title === event.target.value)
          return variant;
      });

      if (!hoverVariant?.featured_media?.position) {
        return;
      }

      this.setCarouselIndex(hoverVariant?.featured_media?.position - 1);
    }

    onVariantHoverStop() {
      this.setCarouselIndex(this.currentVariant?.featured_media.position - 1 || 0);
    }

    setCarouselIndex(index) {
      this.$carousel[0].dataset.selectedVariantIndex = index;
      this.$nav[0].dataset.selectedVariantIndex = index;
    }

    onVariantChangeHandler(e) {

      let variant = this.currentVariant = e.target.currentVariant;
      if (variant) {
        this.setCarouselIndex(variant.featured_media.position - 1 || 0);

        // refresh pickup availability widgets
        if (this.pickupAvailabilityExtended && this.pickupAvailabilityExtended.classList.contains('active')) {
          this.querySelector('pickup-availability-extended').fetchAvailability(variant.id);
        }
      }

      // update prices (overwrites the framework)
      if (!variant) {
        if (this.priceCompact) {
          if (!(this.productVariants.variantRequired && this.productVariants.noVariantSelectedYet)) {
            this.priceCompact.classList.add('hide');
            this.priceCompact.priceOriginal.innerHTML = '';
            this.priceCompact.priceOriginalKit.innerHTML = '';
            this.priceCompact.priceCompareOriginal.innerHTML = '';
            this.priceCompact.priceCompareKit.innerHTML = '';
            this.priceCompact.priceUnit.innerHTML = '';
          }
        }
        if (this.priceExtended) {
          this.priceExtended.classList.add('hide');
          this.priceExtended.priceOriginal.innerHTML = '';
          this.priceExtended.priceOriginalKit.innerHTML = '';
          this.priceCompact.priceCompareOriginal.innerHTML = '';
          this.priceCompact.priceCompareKit.innerHTML = '';
          this.priceExtended.priceUnit.innerHTML = '';
          if (this.priceExtended.priceSaving) {
            this.priceExtended.priceSaving.innerHTML = '';
          }
        }
      } else {
        let kitPrice;
        let comapreAtKitPrice;
        if (variant.print_count < 2) {
          kitPrice = variant.price * 2 + e.target.lumilawnPrice;
          comapreAtKitPrice = variant.compare_at_price * 2 + e.target.lumilawnPrice;
        } else {
          kitPrice = variant.price + e.target.lumilawnPrice;
          comapreAtKitPrice = variant.compare_at_price + e.target.lumilawnPrice;
        }

        if (this.priceCompact) {
          this.priceCompact.classList.remove('hide');
          this.priceCompact.priceOriginal.innerHTML = this.productVariants._formatMoney(variant.price, KROWN.settings.shop_money_format);
          this.priceCompact.priceOriginalKit.innerHTML = this.productVariants._formatMoney(kitPrice, KROWN.settings.shop_money_format);
          if (variant.compare_at_price > variant.price) {
            this.priceCompact.priceCompareOriginal.innerHTML = this.productVariants._formatMoney(variant.compare_at_price, KROWN.settings.shop_money_format);
            //this.priceCompact.priceCompare.innerHTML = `<span>${this.productVariants._formatMoney(variant.compare_at_price, KROWN.settings.shop_money_format)}</span><span class="product-item__badge">-${Math.round(Math.abs((variant.price * 100 / variant.compare_at_price) - 100))}%</span>`;
          } else {
            this.priceCompact.priceCompareOriginal.innerHTML = '';
          }
          if (comapreAtKitPrice > kitPrice) {
            this.priceCompact.priceCompareKit.innerHTML = this.productVariants._formatMoney(comapreAtKitPrice, KROWN.settings.shop_money_format);
            //this.priceCompact.priceCompare.innerHTML = `<span>${this.productVariants._formatMoney(variant.compare_at_price, KROWN.settings.shop_money_format)}</span><span class="product-item__badge">-${Math.round(Math.abs((variant.price * 100 / variant.compare_at_price) - 100))}%</span>`;
          } else {
            this.priceCompact.priceCompareKit.innerHTML = '';
          }

          if (variant.unit_price_measurement) {
            this.priceCompact.priceUnit.innerHTML = `
							${this.productVariants._formatMoney(variant.unit_price, KROWN.settings.shop_money_format)} / 
							${(variant.unit_price_measurement.reference_value != 1 ? variant.unit_price_measurement.reference_value + ' ' : '')}
							${variant.unit_price_measurement.reference_unit}
						`;
          } else {
            this.priceCompact.priceUnit.innerHTML = '';
          }
        }
        if (this.priceExtended) {
          this.priceExtended.classList.remove('hide');
          this.priceExtended.priceOriginal.innerHTML = this.productVariants._formatMoney(variant.price, KROWN.settings.shop_money_format);
          this.priceExtended.priceOriginalKit.innerHTML = this.productVariants._formatMoney(kitPrice, KROWN.settings.shop_money_format);

          // todo: kit version
          if (variant.compare_at_price > variant.price) {
            this.priceExtended.priceCompareOriginal.innerHTML = this.productVariants._formatMoney(variant.compare_at_price, KROWN.settings.shop_money_format);
            //this.priceExtended.priceCompare.innerHTML = `<span>${this.productVariants._formatMoney(variant.compare_at_price, KROWN.settings.shop_money_format)}</span><span class="product-item__badge">-${Math.round(Math.abs((variant.price * 100 / variant.compare_at_price) - 100))}%</span>`;
            if (this.priceExtended.priceSaving) {
              this.priceExtended.priceSaving.innerHTML = `<span>${KROWN.settings.locales.product_compare_price.replace('$SAVE_PRICE', this.productVariants._formatMoney(variant.compare_at_price - variant.price, KROWN.settings.shop_money_format))}</span>`;
            }
          } else {
            this.priceExtended.priceCompareOriginal.innerHTML = '';
            if (this.priceExtended.priceSaving) {
              this.priceExtended.priceSaving.innerHTML = '';
            }
          }

          if (variant.unit_price_measurement) {
            this.priceExtended.priceUnit.innerHTML = `
							${this.productVariants._formatMoney(variant.unit_price, KROWN.settings.shop_money_format)} / 
							${(variant.unit_price_measurement.reference_value != 1 ? variant.unit_price_measurement.reference_value + ' ' : '')}
							${variant.unit_price_measurement.reference_unit}
						`;
          } else {
            this.priceExtended.priceUnit.innerHTML = '';
          }
        }
      }
    }

    _pauseAllMedia() {

      document.querySelectorAll('.product-gallery .js-youtube').forEach(video => {
        video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
      });
      document.querySelectorAll('.product-gallery .js-vimeo').forEach(video => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
      });
      document.querySelectorAll('.product-gallery video').forEach(video => video.pause());
      document.querySelectorAll('.product-gallery product-model').forEach(model => {
        if (model.modelViewerUI)
          model.modelViewerUI.pause()
      });
    }

    _playMedia(media) {
      switch (media.dataset.productMediaType) {
        case 'video':
          if (media.querySelector('video')) {
            media.querySelector('video').play();
          }
          break;
        case 'external_video-youtube':
          if (media.querySelector('.js-youtube')) {
            media.querySelector('.js-youtube').contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
          }
          break;
        case 'external_video-vimeo':
          if (media.querySelector('.js-vimeo')) {
            media.querySelector('.js-vimeo').contentWindow.postMessage('{"method":"play"}', '*');
          }
          break;
      }
    }

  }

  if (typeof customElements.get('product-page') == 'undefined') {
    customElements.define('product-page', ProductPage);
  }

}